import React from 'react';
import { changeSchemesFilter } from '../../common/services/navigation';
import PropTypes from 'prop-types';



function TWICLCertificationsDropdownItem({search, title, options}) {

	const change = e => {
		changeSchemesFilter(search, title.toLowerCase(), e.target.value);
	};

	return (
		<div>
			<label className="visuallyhidden" htmlFor={title}>{title}</label>
			<select id={title} name={title} value={search[title.toLowerCase()]} onChange={change} >
				<option value="">Scheme Type</option>
				{options.map((key, index) => (<option key={index} value={key}>{key}</option>))}
			</select>
		</div>			
	);
}

TWICLCertificationsDropdownItem.propTypes = {
    search: PropTypes.object,
    settings: PropTypes.object,
    filters: PropTypes.object,
    entries: PropTypes.object,
	options: PropTypes.array,
	title: PropTypes.string
};

export default TWICLCertificationsDropdownItem;



